import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FeedOperatorHint } from 'src/app/core/services/feed.service';

@Component({
    selector: 'app-feed-operator-list',
    templateUrl: './feed-operator-list.component.html',
    styleUrls: ['./feed-operator-list.component.scss'],
    standalone: false
})
export class FeedOperatorListComponent {
  @Input() feedOperators: FeedOperatorHint[];

  searchQuery: string;
  filteredFeedOperators: FeedOperatorHint[];

  @Output() onAddOperator = new EventEmitter<string>();

  ngOnInit() {
    this.filteredFeedOperators = this.feedOperators;
  }

  addOperator(feedOperatorHint: FeedOperatorHint) {
    this.onAddOperator.emit(feedOperatorHint.name + ':');
  }

  onSearchChange(newValue: string) {
    if (newValue) {
      this.searchQuery = newValue;
      this.filteredFeedOperators = this.feedOperators.filter((hint) =>
        hint.name.toLowerCase().includes(newValue.toLowerCase()),
      );
    } else {
      this.searchQuery = '';
      this.filteredFeedOperators = this.feedOperators;
    }
  }
}
